module.exports = __webpack_public_path__ + "static/media/footer_img3.7e1faf95.svg";